import { render, staticRenderFns } from "./create-business-profile.vue?vue&type=template&id=336c6735&scoped=true"
import script from "./create-business-profile.vue?vue&type=script&lang=js"
export * from "./create-business-profile.vue?vue&type=script&lang=js"
import style0 from "./create-business-profile.vue?vue&type=style&index=0&id=336c6735&prod&lang=css&scoped=true"
import style1 from "./create-business-profile.vue?vue&type=style&index=1&id=336c6735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c6735",
  null
  
)

export default component.exports